/**
 * @generated SignedSource<<04d559c550982960d3e8d240e99e72e8>>
 * @relayHash df5887286f07e1703a98f99dc3edcd8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 270d0f070189cc815aa8fac233aff1625e8f2de007b3ea6e0dbd82e9e2e3422b

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type agentSessionsMainQuery$variables = {
  after?: string | null;
  aqlQuery: string;
  count: number;
  sharingContext: string;
};
export type agentSessionsMainQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"agentSessionsMainQuery_query">;
};
export type agentSessionsMainQuery = {
  response: agentSessionsMainQuery$data;
  variables: agentSessionsMainQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "aqlQuery"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sharingContext"
},
v4 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v5 = {
  "kind": "Variable",
  "name": "aqlQuery",
  "variableName": "aqlQuery"
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "lastStateChangeAt DESC"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v10 = {
  "kind": "ScalarField",
  "name": "accountId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "agentSessionsMainQuery",
    "selections": [
      {
        "args": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "sharingContext",
            "variableName": "sharingContext"
          }
        ],
        "kind": "FragmentSpread",
        "name": "agentSessionsMainQuery_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "agentSessionsMainQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "AgentSessionConnection",
        "kind": "LinkedField",
        "name": "agent_sessionQuery",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentSessionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentSession",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasUnseenActivity"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "invocationType"
                  },
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "stateReason"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "expireTime"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastStateChangeAt"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isRovo"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "agentAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "convoAiAgentId"
                  },
                  {
                    "alias": "conversationChannel",
                    "concreteType": "AgentConversationChannel",
                    "kind": "LinkedField",
                    "name": "nativeConversationChannel",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "createdAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "interactionChannel"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "interactionChannelAri"
                      },
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "lastMessage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastMessageTimestamp"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastMessageType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastAgentMessageStatus"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "readStatus"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPlanning"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isPinned"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "pinnedAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "picture"
                      },
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "studioAgent",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v8/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "associatedEntities",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "key"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          {
                            "concreteType": "ConfluencePageLinks",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "base"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "webUi"
                              }
                            ]
                          }
                        ],
                        "type": "ConfluencePage"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v6/*: any*/),
        "filters": [
          "shardingContext",
          "aqlQuery",
          "sort"
        ],
        "handle": "connection",
        "key": "agentSessionsMain_agent_sessionQuery",
        "kind": "LinkedHandle",
        "name": "agent_sessionQuery"
      }
    ]
  },
  "params": {
    "id": "270d0f070189cc815aa8fac233aff1625e8f2de007b3ea6e0dbd82e9e2e3422b",
    "metadata": {},
    "name": "agentSessionsMainQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6a5f1117cc06cf56d9e61ef34a6331b6";

export default node;
